import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';

@Component({
    selector: 'bm-bank-transaction-family-details',
    templateUrl: 'bm-bank-transaction-family-details.component.html',
    standalone: false
})
export class BmBankTransactionFamilyDetailsComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() bankTransactionFamilyId: number;

    bankTransactionFamilyWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        this.bankTransactionFamilyWidgetData = WidgetFactory.createWidgetEntityData(
            'bm.bank.transaction.family.details.widget.data',
            'Banktransaktionsfamilie',
            'bm.BankTransactionFamily',
            this.bankTransactionFamilyId
        );
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['bankTransactionFamilyId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
